import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "BlueCross BlueShield of South Carolina",
  shortName: "BCBS South Carolina",
  slug: "sc-blues-insurance",
  seoTitle:
    "BlueCross BlueShield of South Carolina TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how BlueCross BlueShield of South Carolina policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS South Carolina TMS coverage, BlueCross BlueShield SC SPRAVATO authorization, SC Blues mental health benefits Coral Springs FL, BCBS South Carolina depression treatment Florida",
};

export const ScBluesInsurance = () => <InsurancePageTemplate config={config} />;
export default ScBluesInsurance;
